export enum ModuleNotificationsApiTag {
  ModuleLog = "moduleLog",
}
